import {
  Avatar,
  BodyText,
  Breadcrumb,
  CalendarIcon,
  Col,
  Heading,
  HomeIcon,
  JusbrasilIcon,
  JusIaIcon,
  Link,
  Row,
} from '@farol-ds/react'
import { DATE_FORMATTER, DocToolbar, DocToolbarProps } from '@jusbrasil-web/docview/core'
import classNames from 'classnames'

import styles from './blog-header.module.scss'

export interface BlogHeaderProps {
  title: string
  subtitle: string
  publishDate: number
  isJusIAPost: boolean
  publisher: {
    fullname?: string | null
    url?: string | null
    avatar?: {
      urlxl?: string | null
    } | null
  } | null
  document: DocToolbarProps['document']
  viewer: DocToolbarProps['viewer']
  docSearchRef: DocToolbarProps['docSearchRef']
  breadcrumbHref?: string
  breadcrumbLabel?: string
}

export const BlogHeader = ({
  title,
  subtitle,
  publishDate,
  isJusIAPost,
  publisher,
  document,
  viewer,
  docSearchRef,
  breadcrumbHref = '/blog',
  breadcrumbLabel = 'Blog',
}: BlogHeaderProps) => {
  const formattedDate = publishDate ? DATE_FORMATTER.format(publishDate) : null
  const Icon = isJusIAPost ? JusIaIcon : JusbrasilIcon
  const showPublisher = !!publisher?.url && !!publisher.fullname && !!publisher.avatar?.urlxl

  return (
    <div className={classNames(styles.container, { [styles.jusIAPost]: isJusIAPost })}>
      <Row className={styles.containerRow}>
        <Col xs={11} sm={9} md={8} lg={6}>
          <header>
            <Breadcrumb>
              <Breadcrumb.Item disableArrowIcon>
                <Link href="/">
                  <HomeIcon size="sm" />
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item disableArrowIcon style={{ display: 'none' }}>
                <Link href="/">Página Inicial</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link href={breadcrumbHref}>{breadcrumbLabel}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{title}</Breadcrumb.Item>
            </Breadcrumb>
            <div className={styles.headingsContainer}>
              <Heading size="xl" className={styles.heading} asChild>
                <h1>{title}</h1>
              </Heading>
              <BodyText size="md" asChild>
                <h2>{subtitle}</h2>
              </BodyText>
            </div>
            <div className={styles.toolbarContainer}>
              <div className={styles.publicationMetadata}>
                {showPublisher ? (
                  <div className={styles.publicationMetadataItem}>
                    <Avatar
                      src={publisher.avatar?.urlxl || undefined}
                      alt={publisher.fullname || ''}
                      size="md"
                    />
                    <Link type="ghost" href={publisher.url || ''}>
                      <BodyText size="md">{publisher.fullname}</BodyText>
                    </Link>
                  </div>
                ) : (
                  <div className={styles.publicationMetadataItem}>
                    <Icon size="sm" />
                    <BodyText size="md">
                      {`Equipe ${isJusIAPost ? 'Jus IA' : 'Jusbrasil'}`}
                    </BodyText>
                  </div>
                )}
                <div className={styles.publicationMetadataItem}>
                  <CalendarIcon size="sm" />
                  <BodyText size="md">{formattedDate}</BodyText>
                </div>
              </div>
              <DocToolbar document={document} viewer={viewer} docSearchRef={docSearchRef} />
            </div>
          </header>
        </Col>
      </Row>
    </div>
  )
}
